'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.postUserIfNeeded = exports.postUserFailuer = exports.postUserSuccess = exports.postUserRequest = exports.POST_USER_FAILURE = exports.POST_USER_SUCCESS = exports.POST_USER_REQUEST = exports.fetchUsersIfNeeded = exports.failureUsers = exports.receiveUsers = exports.requestUsers = exports.invalidateUsers = exports.filterUsers = exports.INVALIDATE_USERS = exports.FILTER_USERS = exports.FAILURE_USERS = exports.RECEIVE_USERS = exports.REQUEST_USERS = undefined;

var _css = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 客户相关Actions
                                                                                                                                                                                                                                                                   */


var _api = require('../api');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_USERS = exports.REQUEST_USERS = 'REQUEST_USERS';
var RECEIVE_USERS = exports.RECEIVE_USERS = 'RECEIVE_USERS';
var FAILURE_USERS = exports.FAILURE_USERS = 'FAILURE_USERS';
var FILTER_USERS = exports.FILTER_USERS = 'FILTER_USERS';
var INVALIDATE_USERS = exports.INVALIDATE_USERS = 'INVALIDATE_USERS';

var filterUsers = exports.filterUsers = function filterUsers(filter) {
    return {
        type: FILTER_USERS,
        filter: filter
    };
};

var invalidateUsers = exports.invalidateUsers = function invalidateUsers(filter) {
    return {
        type: INVALIDATE_USERS,
        filter: filter
    };
};

var requestUsers = exports.requestUsers = function requestUsers(filter) {
    return {
        type: REQUEST_USERS,
        filter: filter
    };
};

var receiveUsers = exports.receiveUsers = function receiveUsers(filter, response) {
    var users = response.data.map(function (x) {
        return _extends({}, x, {
            id: x.user_id
        });
    });

    return {
        type: RECEIVE_USERS,
        filter: filter,
        users: users,
        pagination: response.meta.pagination
    };
};
var failureUsers = exports.failureUsers = function failureUsers(error) {
    return {
        type: FAILURE_USERS,
        error: error
    };
};

var shouldFetchUsers = function shouldFetchUsers(state, filter) {
    var users = state.user.users;
    if (users.items.length === 0) {
        return true;
    }
    if (users.isFetching) {
        return false;
    }
    // return users.didInvalidate
    return true;
};

var fetchUsersIfNeeded = exports.fetchUsersIfNeeded = function fetchUsersIfNeeded(filter, page) {
    return function (dispatch, getState) {
        if (shouldFetchUsers(getState(), filter)) {
            return dispatch(function (dispatch) {
                dispatch(requestUsers(filter));
                return (0, _api.fetchUsers)(filter, page).then(function (response) {
                    return dispatch(receiveUsers(filter, response.data));
                }).catch(function (error) {

                    dispatch(failureUsers(error));
                });
            });
        }
    };
};

var POST_USER_REQUEST = exports.POST_USER_REQUEST = 'POST_USER_REQUEST';
var POST_USER_SUCCESS = exports.POST_USER_SUCCESS = 'POST_USER_SUCCESS';
var POST_USER_FAILURE = exports.POST_USER_FAILURE = 'POST_USER_FAILURE';

var postUserRequest = exports.postUserRequest = function postUserRequest() {
    return {
        type: POST_USER_REQUEST
    };
};

var postUserSuccess = exports.postUserSuccess = function postUserSuccess(response) {
    return {
        type: POST_USER_SUCCESS
    };
};
var postUserFailuer = exports.postUserFailuer = function postUserFailuer(error) {
    return {
        type: POST_USER_FAILURE,
        error: error
    };
};

var shouldPostUser = function shouldPostUser(state) {
    var users = state.user.users;
    if (users.isPosting) {
        return false;
    }
    return true;
};

var postUserIfNeeded = exports.postUserIfNeeded = function postUserIfNeeded(values, router) {
    return function (dispatch, getState) {
        if (shouldPostUser(getState())) {
            return dispatch(function (dispatch) {
                dispatch(postUserRequest());
                return (0, _api.postUser)(values).then(function (response) {
                    _message2.default.success('提交成功');
                    router.push('/users'); // 二话不说 直接跳转
                    dispatch(fetchUsersIfNeeded());
                    return dispatch(postUserSuccess(response.data));
                }).catch(function (error) {
                    _message2.default.error('提交失败');
                    console.error(error);
                    return dispatch(postUserFailuer(error));
                });
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/user.js
// module id = 882
// module chunks = 0